export default __webpack_public_path__ + "static/media/product_6.60c01cf4.png";